

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

require('components/xo-models/src/checkout/index');

require('components/xo-models/src/app/index');

require('components/xo-models/src/cartButtonParams/index');

require('components/xo-device-info/dist/index');

var _constants = require('./constants');

var _customUtil = require('./customUtil');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

(function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
})(window.angular);

_angular2['default'].module().factory('$Middleware', function ($rootScope, $q, $util, $DeviceInfo, $config, $meta, $FallbackError, $locale, $promise, $populate, $window, $dispatch, $logger, $CartButtonParamsModel) {
    return [function angularDebug() {

        window.root = $rootScope;
        window.injector = _angular2['default'].element(document.body).injector();
    }, function resolveLocale() {
        function retrieveLocale() {
            return $locale.retrieve({
                params: {
                    ipCountry: $meta.ipcountry,
                    checkoutSessionLocale: lcParam,
                    countryParam: $util.param('country.x'),
                    localeParam: $util.param('locale.x') || lcParam,
                    merchantCountry: merchantCountry
                }
            });
        }

        var jsonXclick = _customUtil.customUtil.decodeAndParse($meta.xclickParams);
        var lcParam = jsonXclick && jsonXclick.lc;
        var merchantCountry = jsonXclick && jsonXclick.merchant_country;

        if (jsonXclick && jsonXclick.wa_type === _constants.SHOPPINGCART_WA_TYPE && _constants.EN_DEFAULTS[lcParam]) {
            lcParam = _constants.EN_DEFAULTS[lcParam];
        }

        return retrieveLocale();
    }, function logPage() {

        $logger.info('href', {
            href: window.location.href,
            windowName: $window.name
        });

        /* let match = document.cookie.toString().match(/ectoken=([^;]+)/);
         if (match && match[1] === $rootScope.token) {
            $logger.info('returning_user_same_token');
        } else if (match && match[1] !== $rootScope.token) {
            $logger.info('returning_user_diff_token');
        } else {
            $logger.info('non_returning_user');
        }
         document.cookie = 'ectoken=' + $rootScope.token + '; expires=Fri, 31 Dec 9999 23:59:59 GMT;';
        */
        if (window.performance && window.performance.navigation && _angular2['default'].isDefined(window.performance.navigation.type)) {

            var navigationType = {
                0: 'regular',
                1: 'reload',
                2: 'back_forward'
            }[window.performance.navigation.type];

            if (navigationType) {
                $logger.info('navigation_' + navigationType);
            }
        }
    }, function logPerformance() {
        if (window.enablePerformance) {

            var keys = ['connectEnd', 'connectStart', 'domComplete', 'domContentLoadedEventEnd', 'domContentLoadedEventStart', 'domInteractive', 'domLoading', 'domainLookupEnd', 'domainLookupStart', 'fetchStart', 'loadEventEnd', 'loadEventStart', 'navigationStart', 'redirectEnd', 'redirectStart', 'requestStart', 'responseEnd', 'responseStart', 'secureConnectionStart', 'unloadEventEnd', 'unloadEventStart'];

            var timing = {};

            _angular2['default'].forEach(keys, function (key) {
                timing[key] = parseInt(window.performance.timing[key], 10) || 0;
            });

            var offset = timing.connectEnd - timing.navigationStart;

            if (timing.connectEnd && window.clientStartTime) {
                _angular2['default'].forEach(timing, function (time, name) {
                    if (time && _angular2['default'].isNumber(time)) {
                        $logger.info('timing_' + name, {
                            client_elapsed: time - timing.connectEnd - (window.clientStartTime - offset),
                            req_elapsed: time - timing.connectEnd
                        });
                    }
                });
            }

            $logger.info('timing', timing);

            if (window.performance.memory) {
                $logger.info('memory', window.performance.memory);
            }

            if (window.performance.navigation) {
                $logger.info('navigation', window.performance.navigation);
            }

            if (window.performance.getEntries) {
                _angular2['default'].forEach(window.performance.getEntries(), function (resource) {
                    if (['link', 'script', 'img', 'css'].indexOf(resource.initiatorType) > -1) {
                        $logger.info(resource.initiatorType, resource);
                    }
                });
            }

            if (timing.connectEnd && timing.navigationStart && window.clientStartTime) {
                $logger.info('js_init', {
                    client_elapsed: 0,
                    req_elapsed: window.clientStartTime - offset
                });
            }
        } else {
            $logger.info('no_performance_data');
        }
    }];
});

_constants.SHOPPINGCART_WA_TYPE;

_constants.EN_DEFAULTS;

_customUtil.customUtil;


//////////////////
// WEBPACK FOOTER
// ./js/lib/middleware.js
// module id = ./js/lib/middleware.js
// module chunks = 1